import { render, staticRenderFns } from "./odetail.vue?vue&type=template&id=16478629&scoped=true&"
import script from "./odetail.vue?vue&type=script&lang=js&"
export * from "./odetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16478629",
  null
  
)

export default component.exports